import React from 'react';
import { Trans } from 'react-i18next';
import { EnumUserSharedFormField } from '@components-member/shared/forms/enums';
import { EnumUSTCopyFormField } from '@components-member/socialTrading/shared/modal/copyModal/enums';
import CONSTANTS from '@components-shared/constants';
import { IFormField } from '@components-shared/forms/formField.interface';
import { validationService } from '@components-shared/forms/validators';
import { keyMap } from '@locales/lokalise/keyMap';

export const lotFieldDefaultValue = '1.000';

export const TYPE_FIELD: IFormField = {
  name: EnumUserSharedFormField.type,
  type: 'customSelect',
  options: [],
};

export const PROFIT_SHARING_FIELD: IFormField = {
  name: EnumUserSharedFormField.profitSharing,
  title: keyMap.copyTradingProfitSharingTitle,
  type: 'inputWithSlider',
  attributes: { autoComplete: 'off' },
  defaultValue: 10,
  step: 1,
  minValue: 0,
  maxValue: 100,
  precision: 0,
  hideNumericArrows: true,
};

export const DEPOSIT_AMOUNT: IFormField = {
  name: EnumUserSharedFormField.recommendedMinDepositAmount,
  title: keyMap.tradingAccountsOpenMasterAccountFormRecommendedDeposit,
  type: 'number',
  attributes: { autoComplete: 'off' },
  hideNumericArrows: true,
  tooltip: '',
  isHidden: true,
};

export const MAKE_MIN_DEPOSIT_AMOUNT_REQUIRED: IFormField = {
  name: EnumUserSharedFormField.makeMinDepositAmountRequired,
  title: keyMap.copyTradingMakeMinDepositAmountRequiredTitle,
  type: 'switcher',
  hintMessage: keyMap.copyTradingMakeMinDepositAmountRequiredHint,
  isHidden: true,
};

export const MARGIN_STOP_COPY_LEVEL: IFormField = {
  name: EnumUserSharedFormField.marginStopCopyLevel,
  title: keyMap.tradingAccountsMarginStopCopyLevel,
  required: false,
  type: 'number',
  defaultValue: '',
  attributes: { autoComplete: 'off' },
  step: 0.001,
  isHidden: true,
  precision: 3,
  validator: validationService.isLowerThan(CONSTANTS.MAX_MARGIN_PERCENT_LEVEL),
  tooltip: <Trans i18nKey={keyMap.tradingAccountsMarginStopCopyLevelTooltip} components={{ b: <b /> }} />,
};

export const STOP_COPY_VIA_MARGIN_LEVEL: IFormField = {
  name: EnumUserSharedFormField.stopCopyViaMarginLevel,
  title: keyMap.tradingAccountsStopCopyViaMarginLevel,
  required: false,
  type: 'number',
  defaultValue: '',
  attributes: { autoComplete: 'off' },
  minValue: 100,
  step: 0.001,
  isHidden: true,
  precision: 3,
  allowNegativeValues: false,
  validator: validationService.isEmptyOrGreaterThan(CONSTANTS.MIN_STOP_COPY_VIA_MARGIN_PERCENT_LEVEL),
  tooltip: <Trans i18nKey={keyMap.tradingAccountsStopCopyViaMarginLevelTooltip} components={{ b: <b /> }} />,
};

export const PERCENTAGE_LOSS_STOP_COPY_LEVEL: IFormField = {
  name: EnumUserSharedFormField.percentageLossStopCopyLevel,
  title: keyMap.tradingAccountsPercentageLossStopCopyLevel,
  required: false,
  type: 'number',
  defaultValue: '',
  attributes: { autoComplete: 'off' },
  step: 0.001,
  isHidden: true,
  precision: 3,
  validator: validationService.isLowerThan(CONSTANTS.MAX_MARGIN_PERCENT_LEVEL),
  allowNegativeValues: true,
  tooltip: keyMap.tradingAccountsPercentageLossStopCopyLevelTooltip,
};

export const LOT_FIELD: IFormField = {
  name: EnumUSTCopyFormField.lot,
  title: keyMap.tradingAccountsLotMultiplier,
  type: 'number',
  defaultValue: lotFieldDefaultValue,
  attributes: { autoComplete: 'off' },
  isHidden: true,
  step: 0.001,
  precision: 3,
  required: true,
  tooltip: keyMap.lotMultiplierAllowsYouToMultiplySizeOfYourTradeWithTradeThat,
  validator: validationService.isGreaterThan(0),
};
